<template lang="pug">
.whish-list(v-if="list")
  .header-image(:style="backgroundImage", v-show="!editing")
  croppa.headerImage(v-if="editing", :initial-image="headerImage", :replace-drop="true",
      v-model="headerCroppa", :zoom-speed="19", :prevent-white-space="true",
      :remove-button-color="'#e6041c'", :placeholder="'Eigenes Bild aussuchen ...'",
      :placeholder-font-size="25", auto-sizing)
  section.section.list
    .view-list(v-show="!editing")
      h1.title {{ list.title }}
        a.edit-list(href="#", @click.prevent="startEditing", v-show="myList")
          i.mdi.mdi-pencil.mdi-24x
      .description
        p(v-html="$options.filters.linebreaks(list.description)")

    // EDITING THE WISHLIST
    .form(v-show="editing")
      b-field(
        label="Titel der Wunschliste", :message="listForm.errors.get('title')",
        :type="listForm.errors.isDanger('title')")
        b-input(v-model="listForm.title", @keydown.native="listForm.errors.clear('name')")
      b-field(label="Beschreibung", :message="listForm.errors.get('description')")
        b-input(type="textarea", v-model="listForm.description")
      b-field(label="Veranstaltungsdatum", :message="listForm.errors.get('event_data')")
        datetime(v-model="listForm.event_date", type="datetime",
                 input-class="input", :minute-step="5", :auto="true")

      .button-wrapper
        button.button.is-primary(@click="finishEditing") Speichern

  // add item form
  section.section.items(v-show="myList && !editing")
    .new-item
      b-field(
        label="Name", :message="form.errors.get('name')",
        :type="form.errors.isDanger('name')")
        b-input(v-model="form.name",
        @keyup.native.enter="addItem", @keydown.native="form.errors.clear('name')")
      b-field(label="Beschreibung")
        b-input(type="textarea", v-model="form.description")
      b-field(:message="form.errors.get('link')", label="Link",
              :type="form.errors.isDanger('link')")
        b-input(placeholder="Von URL laden ...", v-model="form.link", expanded,
                @keyup.native.enter="addItem",
                icon="link-variant", @keydown.native="form.errors.clear('link')")

      .button-wrapper
        button.button.is-primary(
          @click="addItem", :class="{'is-loading': newItemLoading}") Hinzufügen

  .filter-wrapper
    b-dropdown.filter(hoverable)
      button.button(slot="trigger")
        i.mdi(:class="sortingMethods[sortingMethod].icon")
        span {{ sortingMethodLabel }}
        b-icon(icon="menu-down")
      a.dropdown-item(v-for="(value, key) in sortingMethods", @click="sortVia(key)", :key="key")
        i.mdi(:class="value.icon")
        | {{ value.name }}

  // all the items in the list
  .item-count.is-size-7
    countdown.details.countdown.is-pulled-left(
        v-if="list.event_date && new Date() < new Date(list.event_date)",
        :time="new Date(list.event_date) - new Date()")
      template(slot-scope="props")
        span(v-if="props.days > 0") Noch：{{ props.days }} Tag
        span(v-if="props.days > 1") e
        span(v-if="props.days === '00'") Heute

    span.details(v-if="$store.getters.registered")
      b-tooltip(:label="list.num_distinct_views + ' unterschiedliche Nutzer'",
                position="is-top")
        span {{ list.num_views }} Ansichten
    span.details {{ reservedItems.length }}/{{ list.items.length }} bereits reserviert
  hr
  section.section.items
    // sortable list for the list owner
    draggable(v-model="list.items", :element="'section'", v-if="myList",
              @start="startSorting", @end="finishSorting", :options="{handle:'.drag-handle'}")
      //slide-y-up-transition(group, :class="{'no-move': sorting}", :duration="slideDuration")
      transition-group(name="slide")
        ListItem(:show="item", @itemDeleted="removeItem", :myList="myList",
                 v-for="item in list.items", :key="item.id", :class="{'no-move': sorting}")

    // normal list for the rest of the world
    transition-group(name="slide")
      ListItem(:show="item", @itemDeleted="removeItem", :myList="myList",
               v-for="item in list.items", :key="item.id", v-if="!myList")
</template>

<script>
import ListItem from '@/components/ListItem.vue'
// import SortableList from '@/components/SortableList.vue'
import Form from '@/core/Form'
import draggable from 'vuedraggable'
import _ from 'lodash'
// import defaultHeaderImage from './../assets/Foto.png'

export default {
  name: 'view-list',
  metaInfo () {
    return {
      title: this.listName,
      titleTemplate: '%s'
    }
  },
  components: {
    ListItem,
    draggable
  },
  data () {
    return {
      headerStartingMeta: null,
      headerCroppa: null,
      sorting: false,
      editing: false,
      list: null,
      order: null,
      form: new Form({
        name: '',
        description: '',
        link: ''
      }),
      monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
      ],
      dayNames: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      newItemLoading: false,
      listForm: new Form({
        title: '',
        description: '',
        event_date: null
      }),
      sortingMethod: 'priority',
      sortingMethods: {
        'priority': {
          name: 'Priorität des Beschenkten',
          icon: 'mdi-star'
        },
        'asc': {
          name: 'Preis aufsteigend',
          icon: 'mdi-arrow-up'
        },
        'desc': {
          name: 'Preis absteigend',
          icon: 'mdi-arrow-down'
        }
      }
    }
  },
  methods: {
    sortVia (key) {
      this.sortingMethod = key
      let newList = this.list.items

      switch (this.sortingMethod) {
        case 'priority':
          this.list.items = _.sortBy(newList, [item => { return item.order }]).reverse()
          break
        case 'asc':
          this.list.items = _.sortBy(newList, [item => { return item.raw_price || 0 }])
          break
        case 'desc':
          this.list.items = _.sortBy(newList, [item => { return item.raw_price || 0 }]).reverse()
      }
    },
    startEditing () {
      this.listForm.title = this.list.title
      this.listForm.description = this.list.description
      this.listForm.event_date = this.list.event_date
      this.editing = true
    },
    submitForm () {
      this.listForm.submit('put', `/lists/${this.list.id}/`).then(data => {
        this.list = data
        this.editing = false
        delete this.$route.query.edit
      }).catch(response => console.log(response))
    },
    finishEditing () {
      if (this.headerCroppa.hasImage()) {
        this.headerCroppa.generateBlob(
          blob => {
            let URL = `/lists/${this.list.id}/`
            let formData = new FormData()
            formData.append('image', blob, 'image.jpg')
            let config = {
              header: {
                'Content-Type': 'multipart/form-data'
              }
            }

            this.axios.put(URL, formData, config).then(response => {
              this.submitForm()
            }).catch(error => {
              console.log('error', error)
            })
          },
          'image/jpeg', 0.8 // 80% compressed jpeg fil
        )
      } else {
        this.submitForm()
      }
    },
    startSorting () {
      this.order = this.list.items.map(item => { return item.id })
      this.sorting = true
    },
    finishSorting () {
      this.sorting = false
      let ids = this.list.items.map(item => { return item.id })
      if (!this.order.every((v, i) => v === ids[i])) {
        this.axios.post('/lists/' + this.list.id + '/order-items', ids)
          .then(response => {
            this.$toast.open({
              message: 'Neue Sortierung gespeichert.',
              type: 'is-success'
            })
          }).catch(response => console.log(response))
      }
    },
    addItem: function () {
      let url = '/lists/' + this.list.id + '/items/'
      this.newItemLoading = true
      this.form.post(url)
        .then(response => {
          this.loadList()
          this.newItemLoading = false
        }).catch(response => {
          console.log(response)
          this.newItemLoading = false
        })
    },
    removeItem: function (event) {
      this.loadList()
    },
    loadList () {
      this.axios.get('lists/' + this.$route.params.token)
        .then(response => {
          this.list = response.data
          if (this.$route.query.edit && this.myList) { this.startEditing() }
        }).catch(response => console.log(response))
    }
  },
  created () {
    this.loadList()
  },
  computed: {
    sortingMethodLabel () {
      if (this.sortingMethod === 'priority') {
        if (this.myList) return 'Meine Priorität'
        else return 'Priorität des Beschenkten'
      }
      return this.sortingMethods[this.sortingMethod].name
    },
    headerImage () {
      if (this.list.image) return this.list.image
      else return null
    },
    listName () {
      return this.list ? this.list.title : 'Meine Liste'
    },
    backgroundImage () {
      if (this.list.image) {
        return `background-image: url(${this.list.image})`
      }
      return ''
    },
    moveClass () {
      if (this.sorting) return 'no-move'
      return ''
    },
    myList () {
      if (!(this.list && this.$store.state.user)) return false
      return this.list.user === this.$store.state.user.id
    },
    reservedItems () {
      let reserved = []
      for (let item of this.list.items) {
        if (item.reserved_by) reserved.push(item)
      }
      return reserved
    }
  }
}
</script>

<style lang="sass">

.section.list
  padding-top: 20px

.headerImage
  svg.icon-remove
    top: 5px !important
    right: 5px !important
    filter: none

.button .icon:last-child:not(:first-child)
  margin-left: 1em

.filter-wrapper
  //text-align: right
  padding: 0 1.5rem
  margin-bottom: 1em
  .filter
    text-align: left
    i
      margin-right: 1em

.edit-list
  margin-left: 0.5em

.sortable-ghost
  background: rgba(73, 157, 73, 0.21)

.no-move
  transition: 0s !important

.slide-enter-active, .slide-leave-active, .slide-move
  transition: 0.3s

.slide-enter-to, .slide-leave
  opacity: 1
  background: rgba(121, 182, 88, 0.2)

.slide-enter, .slide-leave-to
  opacity: 0
  background: #e6041c
  transform: translateY(-15px)

.item-count
  padding: 0 24px
  .countdown
    margin-right: 5px
hr
  margin: 0 24px

section.items
  padding-top: 0

.media-content
  overflow: visible

.headerImage, .header-image
  width: 100%
  padding-bottom: 30%
  position: relative
  canvas
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0

.header-image
  background-image: url("../assets/Foto.png")
  background-size: cover
  background-position: center

h1
  text-align: center

.list-item:not(:first-child)
  border-top: 1px solid #ddd
  &.dragging
    border-top: none

.details + .details
  &:before
    content: ' | '

</style>
